import { c as _c } from "react/compiler-runtime";
import { useIsVisible } from "@website/hooks/is-visible";
import { ReactNode, useEffect } from "react";
interface Properties {
  children: ReactNode;
  remainsCount: number;
  onNextPage: () => void;
  isLoading: boolean;
}
export function Pagination(t0) {
  const $ = _c(11);
  const {
    children,
    remainsCount,
    onNextPage,
    isLoading
  } = t0;
  const {
    reference,
    inView
  } = useIsVisible();
  let t1;
  let t2;
  if ($[0] !== inView || $[1] !== isLoading || $[2] !== onNextPage || $[3] !== remainsCount) {
    t1 = () => {
      if (inView && Boolean(remainsCount) && !isLoading) {
        onNextPage();
      }
    };
    t2 = [inView, onNextPage, remainsCount, isLoading];
    $[0] = inView;
    $[1] = isLoading;
    $[2] = onNextPage;
    $[3] = remainsCount;
    $[4] = t1;
    $[5] = t2;
  } else {
    t1 = $[4];
    t2 = $[5];
  }
  useEffect(t1, t2);
  let t3;
  if ($[6] !== reference) {
    t3 = <div className="flex h-1 w-full justify-center" ref={reference} />;
    $[6] = reference;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== children || $[9] !== t3) {
    t4 = <>{children}{t3}</>;
    $[8] = children;
    $[9] = t3;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  return t4;
}